import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <div className="mb-4">
              <Button
                variant="outline-primary"
                onClick={() => navigate(-1)}
                className="mb-3"
              >
                <i className="fas fa-arrow-left me-2"></i>
                Back
              </Button>
              <h1 className="fw-bold text-dark mb-4">Terms and Conditions</h1>
              <p className="text-muted">Last Updated: March 1, 2026</p>
            </div>

            <div className="bg-white p-4 rounded shadow-sm">
              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">1. Agreement to Terms</h2>
                <p className="text-muted">
                  By accessing and using the NetworqPay platform (the "Service"), you accept and agree to be bound
                  by the terms and provision of this agreement. If you do not agree to abide by the above, please
                  do not use this service.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">2. Use License</h2>
                <p className="text-muted">
                  Permission is granted to temporarily download one copy of the materials (information or software)
                  on NetworqPay's website for personal, non-commercial transitory viewing only. This is the grant of
                  a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="text-muted">
                  <li>Modifying or copying the materials;</li>
                  <li>Using the materials for any commercial purpose or for any public display;</li>
                  <li>Attempting to decompile or reverse engineer any software contained on the website;</li>
                  <li>Removing any copyright or other proprietary notations from the materials;</li>
                  <li>Transferring the materials to another person or "mirroring" the materials on any other server;</li>
                  <li>Violating any applicable laws or regulations related to access to or use of the Service.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">3. Disclaimer</h2>
                <p className="text-muted">
                  The materials on NetworqPay's website are provided on an 'as is' basis. NetworqPay makes no
                  warranties, expressed or implied, and hereby disclaims and negates all other warranties including,
                  without limitation, implied warranties or conditions of merchantability, fitness for a particular
                  purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">4. Limitations</h2>
                <p className="text-muted">
                  In no event shall NetworqPay or its suppliers be liable for any damages (including, without limitation,
                  damages for loss of data or profit, or due to business interruption) arising out of the use or
                  inability to use the materials on the NetworqPay website, even if NetworqPay or an authorized
                  representative has been notified orally or in writing of the possibility of such damage.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">5. Accuracy of Materials</h2>
                <p className="text-muted">
                  The materials appearing on the NetworqPay website could include technical, typographical, or
                  photographic errors. NetworqPay does not warrant that any of the materials on the website are
                  accurate, complete, or current. NetworqPay may make changes to the materials contained on the
                  website at any time without notice.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">6. Links</h2>
                <p className="text-muted">
                  NetworqPay has not reviewed all of the sites linked to its website and is not responsible for the
                  contents of any such linked site. The inclusion of any link does not imply endorsement by NetworqPay
                  of the site. Use of any such linked website is at the user's own risk.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">7. Modifications</h2>
                <p className="text-muted">
                  NetworqPay may revise these terms of service for the website at any time without notice. By using
                  this website, you are agreeing to be bound by the then current version of these terms of service.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">8. Governing Law</h2>
                <p className="text-muted">
                  These terms and conditions are governed by and construed in accordance with the laws of India, and
                  you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">9. User Accounts</h2>
                <p className="text-muted">
                  If you create an account on the NetworqPay platform, you are responsible for maintaining the
                  confidentiality of your account information and password and for restricting access to your
                  computer. You agree to accept responsibility for all activities that occur under your account or
                  password. NetworqPay reserves the right to refuse service, terminate accounts, or remove or edit
                  content in its sole discretion.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">10. Task Completion and Rewards</h2>
                <p className="text-muted">
                  By completing tasks on NetworqPay, you agree to follow all instructions provided. Rewards are given
                  at the sole discretion of NetworqPay and are subject to verification of task completion. NetworqPay
                  reserves the right to withhold or revoke rewards if tasks are deemed incomplete or if terms are violated.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">11. Referral Program</h2>
                <p className="text-muted">
                  The NetworqPay referral program allows users to earn commissions by referring others to the platform.
                  Referral rewards are subject to the completion of specified upgrade levels by referred users. NetworqPay
                  reserves the right to modify or terminate the referral program at any time.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">12. Withdrawal of Funds</h2>
                <p className="text-muted">
                  Users may withdraw earned rewards subject to minimum withdrawal requirements and verification of
                  banking details. NetworqPay reserves the right to delay or deny withdrawal requests if suspicious
                  activity is detected or if terms are violated. Withdrawal processing typically takes 2-3 business days.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">13. Prohibited Activities</h2>
                <p className="text-muted">
                  Users agree not to engage in any of the following activities:
                </p>
                <ul className="text-muted">
                  <li>Violating any applicable laws or regulations;</li>
                  <li>Infringing upon or violating intellectual property rights;</li>
                  <li>Submitting false or fraudulent information;</li>
                  <li>Engaging in any form of harassment or abuse;</li>
                  <li>Attempting to gain unauthorized access to the platform;</li>
                  <li>Using the platform for any illegal or unethical purposes;</li>
                  <li>Manipulating tasks, referrals, or reward systems.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 fw-bold text-dark mb-3">14. Dispute Resolution</h2>
                <p className="text-muted">
                  In the event of a dispute, users agree to first attempt resolution through contact with NetworqPay
                  support. If disputes cannot be resolved, they shall be settled through binding arbitration in
                  accordance with applicable laws.
                </p>
              </section>

              <section>
                <h2 className="h4 fw-bold text-dark mb-3">15. Contact Us</h2>
                <p className="text-muted">
                  If you have any questions about these Terms and Conditions, please contact us at:
                </p>
                <div className="bg-light p-3 rounded mt-3">
                  <p className="mb-1"><strong>Email:</strong> support@networqpay.com</p>
                  <p className="mb-1"><strong>Address:</strong> NetworqPay, India</p>
                  <p className="mb-0"><strong>Support Hours:</strong> Monday - Friday, 9 AM - 6 PM IST</p>
                </div>
              </section>

              <div className="mt-5 pt-4 border-top">
                <p className="text-muted small">
                  By accessing and using NetworqPay, you acknowledge that you have read, understood, and agree to be
                  bound by all of these Terms and Conditions.
                </p>
                <Button
                  onClick={() => navigate('/register')}
                  className="fw-semibold py-2"
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none'
                  }}
                >
                  <i className="fas fa-checkmark me-2"></i>
                  I Agree - Continue to Sign Up
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
